import React , { useCallback } from "react";
import { MotifCard } from "@ey-xd/motif-react";
import { MotifCardHeader } from "@ey-xd/motif-react";
import { MotifCardBody } from "@ey-xd/motif-react";
import { useNavigate } from "react-router-dom";

import "./adminDashboard.scss";

export const AdminDashboard = React.memo(() => {
  const navigate = useNavigate();
  const handleNavigate = useCallback((path) => {
      navigate(path);
    },
    [navigate]);

  return (
    <>
      <div className="admin-dashboard-container">
        <div className="card-wrapper">
          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              handleNavigate("/steps/files");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img fileuploadBg">
                    <img loading="lazy" alt="File Upload" src={require("../../common/images/file-upload.png")} />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">File Upload</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span
                data-toggle="tooltip"
                title="Quick Data Tagging and file transfer from local device to DBS
                platform."
                className="motif-body1-default-light adminTilesDescription"
              >
                Quick Data Tagging and file transfer from local device to DBS
                platform.
              </span>
            </MotifCardBody>
          </MotifCard>
          <div className="arrow">
            <img loading="lazy" alt="arrow" src={require("../../common/images/nav-arrow-right.png")} />
          </div>
          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              handleNavigate("/steps/anonymization");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img anonymizationBg">
                    <img
                      loading="lazy"
                      alt="Anonymization"
                      src={require("../../common/images/anonymization.png")}
                    />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Anonymization</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span
                data-toggle="tooltip"
                title="View Anonymization status and score for the uploaded files."
                className="motif-body1-default-light adminTilesDescription"
              >
                View Anonymization status and score for the uploaded files.
              </span>
            </MotifCardBody>
          </MotifCard>
          <div className="arrow">
            <img loading="lazy" alt="arrow" src={require("../../common/images/nav-arrow-right.png")} />
          </div>
          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              handleNavigate("/steps/quality");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img dataqualityBg">
                    <img loading="lazy" alt="Data Quality"
                      src={require("../../common/images/data-quality.png")}
                    />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Data Quality</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span
                data-toggle="tooltip"
                title=" Monitor Data Quality of the data uploaded on data bureau
                services."
                className="motif-body1-default-light adminTilesDescription"
              >
                Monitor Data Quality of the data uploaded on data bureau
                services.
              </span>
            </MotifCardBody>
          </MotifCard>
          <div className="arrow">
            <img loading="lazy" alt="arrow" src={require("../../common/images/nav-arrow-right.png")} />
          </div>
          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              handleNavigate("/steps/extraction");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img dataextractionBg">
                    <img loading="lazy" alt="Data Layer" src={require("../../common/images/data-layer.png")} />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Data Extraction</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span
                data-toggle="tooltip"
                title="Data Extraction from anonymized files and upload into DBS Raw,
                Standardized and Curated Layer."
                className="motif-body1-default-light adminTilesDescription"
              >
                Data Extraction from anonymized files and upload into DBS Raw,
                Standardized and Curated Layer.
              </span>
            </MotifCardBody>
          </MotifCard>
          <div className="arrow">
            <img loading="lazy" alt="arrow" src={require("../../common/images/nav-arrow-right.png")} />
          </div>

          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              handleNavigate("/steps/insights");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img insightsBg">
                    <img loading="lazy" alt="Insights" src={require("../../common/images/insights.png")} />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Insights</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span
                data-toggle="tooltip"
                title="A non-attributable and anonymized trend generation for industry,
                sector, domain, geography, time frame"
                className="motif-body1-default-light adminTilesDescription"
              >
                A non-attributable and anonymized trend generation for industry,
                sector, domain, geography, time frame
              </span>
            </MotifCardBody>
          </MotifCard>
        </div>
      </div>
    </>
  );
});
 